import { useEffect, useRef, useState } from "react";
import ProgressBar from "../components/ProgressBar";
import { useLocation } from "react-router-dom";

export default function ResultPage() {
  const location = useLocation();
  const wrapperRef = useRef();
  const lastSentHeight = useRef(0);
  const [totalScores, setTotalScores] = useState(location.state?.totalScores || null);
  const [scores, setScores] = useState(location.state?.scores || null);

  useEffect(() => {
    const savedScores = localStorage.getItem('scores');
    const savedTotalScores = localStorage.getItem('totalScores')
    if (!scores || !totalScores) {
      if (savedScores && savedTotalScores) {
        setScores(JSON.parse(savedScores));
        setTotalScores(JSON.parse(savedTotalScores));

        localStorage.removeItem('scores');
        localStorage.removeItem('totalScores');
      }
    }

    if (savedScores && savedTotalScores) {
        localStorage.removeItem('scores');
        localStorage.removeItem('totalScores');
      }

    const observer = new ResizeObserver(() => {
      const height = wrapperRef.current?.scrollHeight;
      if (height && Math.abs(height - lastSentHeight.current) > 20) {
        window.parent.postMessage(
          { type: "setHeight", height: height },
          "*"
        );
        lastSentHeight.current = height;
      }
    });
    window.parent.postMessage(
        { type: "quizCompleted", test: "adhd_quiz" },
        "*"
    );

    if (wrapperRef.current) observer.observe(wrapperRef.current);
    return () => observer.disconnect();
  }, [scores, totalScores]);

  if (!scores || !totalScores) {
  return <p>Laddar resultat...</p>;
}

  return (
    <div ref={wrapperRef} className="questionnaire-adhd">
      <div className="results">
            <h2>Resultat</h2>
            {Object.entries(scores).map(([category, score]) => (
                <div key={category}>
                    <p>{category}</p>
                    <ProgressBar
                        current={score}
                        total={totalScores[category]}
                    />
                </div>
            ))}
            <div className='results-text'>
                <h2>Hur du kan tolka ditt resultat</h2>
                <p><strong>0–17 poäng på båda skalorna: </strong>Det är mindre troligt att du har ADHD.</p>
                <p><strong>17–23 poäng på någon av skalorna: </strong>Det finns tecken som tyder på att ADHD kan förekomma.</p>
                <p><strong>24 poäng eller mer på någon av skalorna: </strong>Det är starka indikationer på att ADHD kan föreligga.</p>
                <h3>Viktigt att veta:</h3>
                <p>En diagnos kan endast ställas genom en noggrann utredning av legitimerad psykolog och läkare. Det här testet ger bara en vägledande bild.</p>
                <p>Har du hög poäng på ouppmärksamhet men låg på hyperaktivitet/impulsivitet? Det kan stämma in på den form av ADHD som tidigare kallades "ADD", och som idag benämns <strong>ADHD – huvudsakligen ouppmärksam form.</strong></p>
                <h3>Vad du kan göra</h3>
                <p>Oavsett vad du får för resultat i testet kan du boka en kostnadsfri konsultation hos Sveapsykologerna om du upplever att koncentrationssvårigheter, impulsivitet eller rastlöshet påverkar din vardag. Testet är ett verktyg – inte ett svar.</p>
            </div>
        </div>
    </div>
  );
}
